import styled from 'styled-components';
import { Flex } from '../Flex';
export var ModalFooter = styled(Flex).attrs({
  alignItems: 'center',
  justifyContent: 'flex-end',
  px: 's',
  py: 'xxs',
  borderTopWidth: '1px',
  borderTopStyle: 'solid',
  borderTopColor: 'grey.light',
  backgroundColor: 'base.white',
  'data-test': 'modal-footer'
}).withConfig({
  displayName: "ModalFooter",
  componentId: "sc-1dkh2xg-0"
})(["position:sticky;bottom:0;left:0;flex-shrink:0;"]);